/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Audience_LabelInputs */



/**
* | output |
* | --- |
* | "For whom" |
*
* @param {Settings_Template_Audience_LabelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_audience_label = /** @type {((inputs?: Settings_Template_Audience_LabelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Audience_LabelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voor wie")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Pour qui")
	return /** @type {LocalizedString} */ ("For whom")
});